<template>
  <div class="anal-data-master-container" :class="{ 'modal-open': hasActiveModal }" v-if="drilldownData">
    <div class="frequencia-anal-container">
      <div class="freq-header">
        <span v-text="$t('groupings_groups')"></span>
        <span v-text="$t('minimum_month')"></span>
        <span v-text="$t('maximum_month')"></span>
        <span v-text="$t('maximum_week')"></span>
        <span v-text="$t('total_month')"></span>
        <span v-text="$t('PU_contribution')"></span>
      </div>
      <div class="freq-data-cont">
        <div class="agrup-cont" v-for="agp in drilldownData">
          <div class="agrup-data">
            <div class="name">
              <span v-text="agp.nm_agrupamento_grupo" @click="changeIncVisib(agp)"></span>
              
            <!-- TODO - componente para mostrar os grupos por colunas-->
            <!--  <DistributionOfIncidences :visible="ActiveDist" :incidences="agp.distribution_of_incidences" :agp="agp" @changeVisOfDistribuition="changeIncVisib()"></DistributionOfIncidences> -->
            </div>
            <div class="freq-container">
              <span class="frequencias" v-text="agp.freq.qt_min_mes || '--'"></span>
              <span class="frequencias" v-text="agp.freq.qt_max_mes || '--'"></span>
              <span class="frequencias" v-text="agp.freq.qt_max_sem || '--'"></span>
              <span class="frequencias" v-text="agp.qt_utilizado || '--'"></span>
              <span class="frequencias" v-text="'R$ ' + parseFloat(agp.vlr_pu).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
            </div>
          </div>

          <div class="group-data" v-for="(gp,key) in agp.grupos">
            <div class="name" :class="{'isUnderOrOver': gp.freqError}">
              <span :key="key" v-text="gp.nm_grupo" @click="changeUtVisible(gp)"></span>
              <AnalPratUtil :visible="ActiveUtil === gp.id_grupo" :grupo="gp.utilizacao"></AnalPratUtil>
              <img
                class="lackOfCost"
                v-if="gp.id_sem_custo"
                :src="moneyIcon"
                :title="$t('dishes_have_no_cost_or_the_cost_is_out_of_date')"
              />
            </div>
            <div class="freq-container" :class="{'isUnderOrOver': gp.freqError}">
              <span class="frequencias" v-text="gp.freq.qt_min_mes || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="gp.freq.qt_max_mes || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="gp.freq.qt_max_sem || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="gp.qt_utilizado || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="'R$ ' + parseFloat(gp.vlr_pu).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')" @click="changePratoVisib(gp)"></span>
              <AnalResultPrato
                :visible="ActivePratos === gp.id_grupo"
                :pratoList="gp.pratos"
              ></AnalResultPrato>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasActiveModal" class="overlay visible" @click="closeAllModals"></div>
  </div>
</template>
<script>
import AnalResultPrato from "@/components/src/AnalResultPratoComponent";
import AnalPratUtil from "@/components/src/AnalPratUtilComponent";
import DistributionOfIncidences from "@/components/src/distributionOfIncidencesComponent";

export default {
  name: "AnalDataContainer",
  props: {
    drilldownData: {
      type: Array,
      required: true
    }
  },
  components: {
    AnalResultPrato,
    AnalPratUtil,
    DistributionOfIncidences
  },
  data() {
    return {
      moneyIcon: require("../../../static/sifrao.png"),
      ActivePratos: null,
      ActiveUtil: null,
      ActiveDist: false,
    };
  },
  computed: {
    hasActiveModal() {
      return Boolean(this.ActivePratos || this.ActiveUtil);
    }
  },
  methods: {
    changeIncVisib: function(gp) {
      this.ActiveDist = this.ActiveDist ? null : gp.id_grupo;
    },
    changePratoVisib: function(gp) {
      const groupId = gp && gp.id_grupo;
      this.ActivePratos = this.ActivePratos === groupId ? null : groupId;
      if (this.ActivePratos) {
        this.ActiveUtil = null;
      }
    },
    changeUtVisible: function(gp) {
      const groupId = gp && gp.id_grupo;
      this.ActiveUtil = this.ActiveUtil === groupId ? null : groupId;
      if (this.ActiveUtil) {
        this.ActivePratos = null;
      }
    },
    closeAllModals() {
      this.ActivePratos = null;
      this.ActiveUtil = null;
    }
  }
};
</script>
<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.frequencia-anal-container {
  --optimizer-motion-duration: 160ms;
  --optimizer-motion-ease: cubic-bezier(0.22, 1, 0.36, 1);

  margin-top: 18px;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid rgba(33, 33, 70, 0.08);
  background: linear-gradient(180deg, #f9fbff 0%, #f4f7fe 100%);
  /deep/ .pratos-container,
  /deep/ .inc-container {
    display: none;
  }

  /deep/ .pratos-container.visible,
  /deep/ .inc-container.visible {
    position: fixed;
    z-index: 10021;
    background: #fff;
    width: calc(100vw - 140px);
    max-width: 1120px;
    min-width: 320px;
    overflow: auto;
    max-height: calc(100vh - 120px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    display: block;
    border-radius: 12px;
    border: 1px solid rgba(33, 33, 70, 0.12);
    box-shadow: 0 24px 45px rgba(11, 18, 38, 0.32);
    pointer-events: auto;
    animation: modalPopIn var(--optimizer-motion-duration) var(--optimizer-motion-ease);
  }

  /deep/ .inc-container.visible {
    //pointer-events: none;
    max-height: calc(100vh - 15%);
    background: transparent;
    width: calc(100vw - 15%);
    overflow: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: auto;
    display: inline-flex;
    cursor: auto;
  }
  .overlay {
    position: fixed;
    .full;
    background: rgba(8, 12, 26, 0.5);
    backdrop-filter: blur(1px);
    display: none;
    inset: 0;
    pointer-events: auto;
    &.visible {
      display: block;
      z-index: 10020;
      animation: modalFadeIn var(--optimizer-motion-duration) var(--optimizer-motion-ease);
    }
  }
  .overlay,
  .pratos-container {
    cursor: default;
  }
  .freq-header {
    display: grid;
    @size: calc((100% - 25%) / 5);
    grid-template-columns: 25% @size @size @size @size @size;
    background: linear-gradient(160deg, #24244f 0%, #1e2c6c 100%);
    color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(19, 24, 41, 0.16);
    span {
      text-align: center;
      padding: 8px 4px;
      text-transform: uppercase;
      font-size: 0.7rem;
      font-weight: 600;
    }
  }
  .freq-data-cont {
    position: relative;
    display: block;
    max-height: calc(100vh - 100px);
    overflow: auto;
    padding: 8px 2px 12px;
    font-size: 13px;
    border: 1px solid rgba(33, 33, 70, 0.08);
    border-radius: 10px;
    background: #fff;
    margin-top: 8px;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(70, 83, 124, 0.45);
      border-radius: 999px;
    }

    span {
      padding: 7px 0;
    }
  }
  .agrup-cont {
    margin: 10px 6px 0;
    border: 1px solid rgba(33, 33, 70, 0.08);
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 3px 12px rgba(19, 24, 41, 0.06);

    &:first-of-type {
      margin-top: 5px;
    }

    .agrup-data {
      background: rgba(113, 129, 170, 0.14);

      .name {
        position: relative;

        span:not(.frequencias) {
          font-weight: 700;
          color: #1f2747;
        }
      }
    }
    .agrup-data,
    .group-data {
      position: relative;
      display: grid;
      grid-template-columns: 25% 75%;
      cursor: pointer;

      span:not(.frequencias) {
        padding: 8px 8px;
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .name.isUnderOrOver {
        > span {
          color: #c62828;
        }
      }
      .freq-container {
        position: relative;
        display: grid;
        grid-template-columns: 100%/5 100%/5 100%/5 100%/5 100%/5;

        .frequencias {
          text-align: center;
          color: #212146;
          font-weight: 600;
        }

        &.isUnderOrOver {
          > span:not(:last-of-type) {
            color: #c62828;
          }
        }
      }
      &:before {
        content: "";
        position: absolute;
        pointer-events: none;
      }
      &:hover {
        &:before {
          content: "";
          .full;
          border: solid 1px rgba(220, 20, 61, 0.35);
        }
      }
      .lackOfCost {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 5px;
        max-width: 15px;
        margin: auto;
        z-index: 3;
      }
    }
    .group-data {
      &:nth-of-type(2n) {
        background: rgba(242, 245, 252, 0.9);
      }
    }
  }
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes modalPopIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.anal-data-master-container.modal-open {
  position: relative;
  z-index: 10019;
}
.anal-data-container {
  margin: 10px 35px 0 5px;
  position: relative;
  display: grid;
  @larg: 100% /7;
  grid-template-columns: @larg @larg @larg @larg @larg @larg @larg;
  .anal-data {
    position: relative;
    display: block;
    &:before {
      content: "";
      position: absolute;
      .full;
      border: solid 1px white;
    }
    span {
      text-align: center;
      display: block;
      &:first-of-type {
        background: @azul;
        color: white;
      }
    }
  }
}

@media screen and (max-width: 1271px) {
  .frequencia-anal-container {
    .freq-header {
      font-size: 0.68rem;
    }

    .agrup-data,
    .group-data {
      grid-template-columns: 35% 65%;
    }
  }
}

@media screen and (max-width: 900px) {
  .frequencia-anal-container {
    padding: 8px;

    .freq-header {
      @size: calc((100% - 38%) / 5);
      grid-template-columns: 38% @size @size @size @size @size;
    }

    .agrup-data,
    .group-data {
      grid-template-columns: 38% 62%;
    }
  }
}

@media screen and (max-width: 640px) {
  .frequencia-anal-container {
    .freq-header,
    .agrup-data,
    .group-data {
      grid-template-columns: 1fr;
    }

    .freq-container {
      border-top: 1px solid rgba(33, 33, 70, 0.09);
    }

    .pratos-container.visible {
      width: calc(100vw - 22px);
      max-height: calc(100vh - 30px);
    }
  }
}
</style>
